var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec1Icon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec1Icon3",
    transform: "translate(-1286 -818)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1113",
    "data-name": "\\uD0C0\\uC6D0 1113",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(1286 818)",
    fill: "#eaf8fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "premium-icon-tool-2080953",
    transform: "translate(1207.839 832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33851",
    "data-name": "\\uD328\\uC2A4 33851",
    d: "M351.724,249.481h1.857v13.66h-1.857Z",
    transform: "translate(-235.914 -233.036)",
    fill: "#e2dee2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33852",
    "data-name": "\\uD328\\uC2A4 33852",
    d: "M365.813,249.481h.929v13.66h-.929Z",
    transform: "translate(-249.075 -233.036)",
    fill: "#cbc4cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33853",
    "data-name": "\\uD328\\uC2A4 33853",
    d: "M345.475,447.025h-1.857l-.543,1.5a.481.481,0,0,0-.01.3l.619,2.142a.481.481,0,0,0,.462.347h.8a.481.481,0,0,0,.462-.347l.619-2.142a.481.481,0,0,0-.01-.3Z",
    transform: "translate(-227.808 -417.558)",
    fill: "#7a6d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33854",
    "data-name": "\\uD328\\uC2A4 33854",
    d: "M335.89,225.554h-3.484a.493.493,0,0,1-.493-.493V223.4h4.469v1.656A.493.493,0,0,1,335.89,225.554Z",
    transform: "translate(-217.409 -208.679)",
    fill: "#fea613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33855",
    "data-name": "\\uD328\\uC2A4 33855",
    d: "M324.2,15.037h-4.609a.8.8,0,0,1-.8-.8V.8a.8.8,0,0,1,.8-.8H324.2a.8.8,0,0,1,.8.8V14.242a.8.8,0,0,1-.8.8Z",
    transform: "translate(-205.152 -0.003)",
    fill: "#fdb441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33856",
    "data-name": "\\uD328\\uC2A4 33856",
    d: "M384.211.8V14.24a.8.8,0,0,1-.8.795h-1.225a.8.8,0,0,0,.8-.795V.8a.8.8,0,0,0-.8-.8h1.225a.8.8,0,0,1,.8.8Z",
    transform: "translate(-264.373)",
    fill: "#fac600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33857",
    "data-name": "\\uD328\\uC2A4 33857",
    d: "M110.939,5.091a5.886,5.886,0,0,0-2.874-5.06.2.2,0,0,0-.3.172V4.4a.294.294,0,0,1-.1.217l-2.419,2.2a.294.294,0,0,1-.4,0l-2.419-2.2a.294.294,0,0,1-.1-.217V.2a.2.2,0,0,0-.3-.172A5.886,5.886,0,0,0,102.2,10.24a1.108,1.108,0,0,1,.568.968V31.472a2.279,2.279,0,0,0,4.559,0V11.214a1.108,1.108,0,0,1,.57-.969,5.887,5.887,0,0,0,3.039-5.155Z",
    transform: "translate(-1 -0.002)",
    fill: "#7a6d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33858",
    "data-name": "\\uD328\\uC2A4 33858",
    d: "M174.016,5.091a5.886,5.886,0,0,1-3.04,5.154,1.108,1.108,0,0,0-.57.97V31.473a2.279,2.279,0,0,1-3.718,1.769,2.28,2.28,0,0,0,2.062-2.27V10.714a1.107,1.107,0,0,1,.571-.969,5.89,5.89,0,0,0,1.518-9.1V.2a.2.2,0,0,1,.3-.172,5.886,5.886,0,0,1,2.874,5.06Z",
    transform: "translate(-64.077 -0.003)",
    fill: "#685e68"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1114",
    "data-name": "\\uD0C0\\uC6D0 1114",
    cx: 0.637,
    cy: 0.637,
    r: 0.637,
    transform: "translate(103.413 30.495)",
    fill: "#433f43"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56460",
    "data-name": "\\uADF8\\uB8F9 56460",
    transform: "translate(115.164 1.486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33859",
    "data-name": "\\uD328\\uC2A4 33859",
    d: "M342.43,34.6a.494.494,0,0,1-.494-.494V23.035a.494.494,0,0,1,.989,0V34.11A.494.494,0,0,1,342.43,34.6Z",
    transform: "translate(-341.936 -22.541)",
    fill: "#7a6d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33860",
    "data-name": "\\uD328\\uC2A4 33860",
    d: "M375.185,34.6a.494.494,0,0,1-.494-.494V23.035a.494.494,0,0,1,.989,0V34.11A.494.494,0,0,1,375.185,34.6Z",
    transform: "translate(-372.532 -22.541)",
    fill: "#7a6d79"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec1Icon3);
export default __webpack_public_path__ + "static/media/sec1Icon3.9a841c11a21942b2135605dca8fe8516.svg";
export { ForwardRef as ReactComponent };